/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class VatField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Tier Level</label>
        <Input
          label={{ content: 'Level' }}
          labelPosition="right"
          placeholder="e.g 1,2,3...5"
          type="number"
          min="0"
          required
          onChange={e => onChange('tier', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/tierField.js